import type { Filter } from '@repo/common/types/FilterSet';

// Convenience methods for creating complete filters (without counts)
export const createTagFilter = (): Omit<Filter, 'counts'> => ({
  title: 'Tags',
  options: [],
  icon: 'pricetag-outline'
});

export const createSpaceFilter = (): Omit<Filter, 'counts'> => ({
  title: 'Spaces',
  options: [],
  icon: 'folder-outline'
});

export const createCalendarFilter = (): Omit<Filter, 'counts'> => ({
  title: 'Calendars',
  options: [],
  icon: 'calendar'
});

// Helper function to create a filter with counts
export const createFilterWithCounts = (
  baseFilter: Omit<Filter, 'counts'>,
  counts: Record<string, number>
): Filter => ({
  ...baseFilter,
  counts
});
